import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  isAuthenticated = false;

  constructor(private oidcSecurityService: OidcSecurityService, private router: Router) {}

  ngOnInit() {
    // // Check if user is authenticated
    // this.oidcSecurityService.checkAuth().subscribe(({ isAuthenticated }) => {
    //   this.isAuthenticated = isAuthenticated;
    //   console.log('User is authenticated:', isAuthenticated);
    //   // this.router.navigate(['/doctor-panel/dashboard']);
    //   // If not authenticated, trigger login
    //   if (!isAuthenticated) {
    //     console.warn('User is not authenticated. Redirecting to login...');
    //     this.oidcSecurityService.authorize();
    //   }
    // });
  }
}
